import { cva } from '@/styled-system/css';

export const tableCellSharedRecipe = cva({
  base: {
    'backgroundColor': 'bg.action.neutral.alt.default',
    'color': 'text.neutral',
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'background-color 200ms ease',
    },

    '& .c11n_checkbox': {
      verticalAlign: 'text-top',
    },

    '& .c11n_radio': {
      verticalAlign: 'text-top',
    },
  },
  variants: {
    align: {
      left: { textAlign: 'left' },
      center: { textAlign: 'center' },
      right: { textAlign: 'right' },
      start: { textAlign: 'start' },
      end: { textAlign: 'end' },
    },
    appearance: {
      bare: {},
      horizontal: {},
      grid: {
        borderInlineEndWidth: 'default',
        borderInlineEndStyle: 'solid',
        borderInlineEndColor: 'border.muted-alt',
        borderBlockEndWidth: 'default',
        borderBlockEndStyle: 'solid',
        borderBlockEndColor: 'border.muted-alt',
      },
      zebra: {
        '.c11n_table__body > .c11n_table__row:nth-child(odd) &': {
          backgroundColor: 'Table.Cell.bg.zebra',
        },
      },
    },
    size: {
      sm: {
        paddingBlock: 'tighter',
        paddingInline: 'default',
      },
      md: {
        paddingBlock: 'tight',
        paddingInline: 'default',
      },
      lg: {
        paddingBlock: 'default',
        paddingInline: 'default',
      },
    },
  },
  compoundVariants: [
    {
      appearance: ['horizontal', 'zebra'],
      css: {
        borderBlockEndWidth: 'default',
        borderBlockEndStyle: 'solid',
        borderBlockEndColor: 'border.muted-alt',
      },
    },
  ],
});
